import { fetchFavoriteChannelsQuery } from './queries';

export async function fetchFavoriteChannels(): Promise<Map<number, number>> {
  const favoriteChannelsData = await fetchFavoriteChannelsQuery();

  return favoriteChannelsData?.favoritePositions;
}
